import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Common.css';

// Import local images
import heroDoctors from '../assets/images/first.png';
import microscopeLab from '../assets/images/sec.png';
import medicalOffice from '../assets/images/third.jpg';

const Home = ({ onNavigate }) => {
  const handleContactClick = () => {
    if (onNavigate) {
      onNavigate('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleAboutClick = () => {
    if (onNavigate) {
      onNavigate('about');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="hero-title">Ready to Equip Your Healthcare Vision?</h1>
              <p className="hero-text">
                For Busy Professionals Seeking the Best Value in Healthcare Equipment and Supplies
              </p>
              <button className="btn-primary-custom" onClick={handleContactClick}>
                Contact Us
              </button>
            </div>
            <div className="col-lg-6">
              <img
                src={heroDoctors}
                alt="Healthcare professionals"
                className="hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src={microscopeLab}
                alt="Medical professional with microscope"
                className="about-image"
              />
            </div>
            <div className="col-lg-6">
              <span className="section-label">About</span>
              <h2 className="section-title">Ready to Equip Your Healthcare Vision?</h2>
              <p className="section-text">
                At Orthomed, we understand the demands on your time. That's why we're dedicated to making your procurement process as efficient as possible. We specialize in providing a comprehensive range of cutting-edge equipment and supplies to healthcare professionals in various fields.
              </p>
              <button className="btn-secondary-custom" onClick={handleAboutClick}>
                Read more
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="container">
          <h2 className="section-title mb-7">Why Choose Us?</h2>
          <p className="intro-text text-center mb-5">
            At Orthomed, we are committed to serving the healthcare industry with top-quality medical equipment and supplies, tailored to the needs of busy professionals. Whether you’re in family practice, physical therapy, rehabilitation, or chiropractic care, we have the latest tools to support your work.
          </p>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="feature-card">
                <div className="feature-icon">
                  <span className="icon-circle">i</span>
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">Exceptional Quality and Value</h3>
                  <p className="feature-text">
                    We partner with trusted manufacturers like Chattanooga, Clinton, Globe Scientific, and more to bring you the best products at competitive prices. Our direct relationships with these manufacturers ensure that we can meet your needs with precision and speed.
                  </p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <span className="icon-circle">i</span>
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">Commitment to Excellence</h3>
                  <p className="feature-text">
                    We understand the importance of reliable and prompt service. Our team is dedicated to providing you with accurate, detailed quotes and ensuring timely delivery to your location. Simply let us know your requirements, and we’ll handle the rest.
                  </p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <span className="icon-circle">i</span>
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">Customer-Centric Approach</h3>
                  <p className="feature-text">
                    Your satisfaction is our priority. Our flexible service options and commitment to quality make us the go-to choice for healthcare professionals seeking the best in medical equipment and supplies.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <img
                src={medicalOffice}
                alt="Medical office interior"
                className="office-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">
            <div className="row align-items-center">
              <div className="col-lg-8 mb-3 mb-lg-0">
                <h3 className="cta-title">Contact us today to learn more about our products.</h3>
              </div>
              <div className="col-lg-4 text-lg-end">
                <button className="btn-cta" onClick={handleContactClick}>
                  Contact Us Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;